import { Dialog, DialogActions, Typography } from "@mui/material";

const ValidSequenceRangeModal = ({
  showValidRangeModal,
  setShowValidRangeModal,
}) => {
  return (
    <Dialog
      open={showValidRangeModal}
      onClose={() => setShowValidRangeModal(false)}
    >
      <div
        style={{
          width: "400px",
          padding: "20px",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          No Drugs Found
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          The selected ranges dont have any available drugs.Please Adjust them.
        </Typography>
      </div>
      <DialogActions>
        <button
          className="create-btn-outlined"
          style={{ width: "120px" }}
          onClick={() => {
            setShowValidRangeModal(false);
          }}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidSequenceRangeModal;
